module.exports = __webpack_public_path__ + "img/user_icon.b49ae640.svg";